/* custom-guide-maaling.js

   Måler hva pluggene i brødteksten gjør. To ting skjer ved et klikk.

   1. Kjøp. Guiden og kortet skrives som attributter på handlekurven.
      Attributtene følger handlekurven og havner på ordren, så kjøp kan leses
      tilbake til artikkelen i Shopify Admin. Dette er eksakt, uten sampling
      og uten samtykke, fordi det er butikkens egne data.

   2. Klikk. Samme klikk sendes som en hendelse til Fathom, som teller
      klikkene. Fathom er cookiefri og teller alle, ikke bare de som godtar
      banneret. Er ikke Fathom satt opp, skjer ingenting.

   Klikkraten per guide er klikk fra Fathom delt på økter fra Shopify Analytics.
   Kjøpsraten er ordrer med attributtet delt på klikk.

   Hvorfor ikke UTM: interne UTM-lenker starter en ny økt i Shopify og
   overskriver den ekte kilden. Melilot har allerede dårlig attribusjon, og
   UTM på interne lenker ville gjort den verre, ikke bedre.

   sendBeacon brukes fordi den overlever at siden navigerer bort med en gang. */

(function () {
  'use strict';

  function skrivAttributt(guide, element) {
    var kropp = JSON.stringify({
      attributes: { 'Guide': guide, 'Guide-element': element || '' }
    });
    try {
      if (navigator.sendBeacon) {
        navigator.sendBeacon('/cart/update.js', new Blob([kropp], { type: 'application/json' }));
        return;
      }
    } catch (e) { /* faller gjennom */ }
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: kropp,
        keepalive: true
      });
    } catch (e) { /* stille. Måling skal aldri stoppe et klikk. */ }
  }

  function tellIFathom(guide, element) {
    try {
      if (!window.fathom || typeof window.fathom.trackEvent !== 'function') return;
      window.fathom.trackEvent('Pluggklikk');
      window.fathom.trackEvent('Pluggklikk: ' + guide + ' / ' + (element || 'ukjent'));
    } catch (e) { /* stille */ }
  }

  document.addEventListener('click', function (hendelse) {
    if (!hendelse.target || !hendelse.target.closest) return;
    var kort = hendelse.target.closest('[data-guide]');
    if (!kort) return;
    var guide = kort.getAttribute('data-guide');
    var element = kort.getAttribute('data-guide-element');
    skrivAttributt(guide, element);
    tellIFathom(guide, element);
  }, true);
}());
